import React from "react";
import "./dashboard.css";
import { capitalize } from "../../Assets/functions/work-with-strings.js";
import { useState, useEffect } from "react";
import { GrEdit } from "react-icons/gr";
import { MdDeleteForever } from "react-icons/md";
import UpdateModal from "../Modals/UpdateModal.jsx";
import DeleteModal from "../Modals/DeleteModal.jsx";
import { useAppContext } from "../../Context/AppContext.jsx";
import AddModal from "../Modals/AddModal.jsx";
import { Toaster, toast } from "sonner";
import { useFilterContext } from "../../Context/FilterContext.jsx";
import sleep from "../Functions/sleep.jsx";
import ProductsHeader from "./ProductsHeader.jsx";

const DashboardProducts = () => {
  const { changes } = useAppContext();
  const { filters, searchText } = useFilterContext();
  const [url, setUrl] = useState(process.env.REACT_APP_URL);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalUpdateOpen, setIsModalUpdateOpen] = useState(false);
  const [toUpdate, setToUpdate] = useState(null);
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  const [toDelete, setToDelete] = useState(null);
  const [isModalAddOpen, setIsModalAddOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);

  useEffect(() => {
    const updateUrl = () => {
      let updatedUrl = process.env.REACT_APP_URL + "api/menu";
      if (searchText) {
        const base = process.env.REACT_APP_URL + "api/menu";
        updatedUrl = base + "?name=" + searchText;
      }

      if (url !== updatedUrl) {
        setUrl(updatedUrl);
      }
    };

    updateUrl();
  }, [searchText, filters]);

  const getCols = () => {
    if (data && data.length > 0) {
      const col = Object.keys(data[0]);

      col.unshift("Options");
      if (selectedColumns.length === 0) {
        let aux = [];
        for (let i = 0; i < col.length; i++) {
          aux.push(true);
        }
        setSelectedColumns(aux);
      }
      setColumns(col);
    }
  };

  useEffect(() => {
    getCols();
  }, [data.length]);

  const fetchData = async () => {
    try {
      await sleep(1000);
      const response = await fetch(url, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error("Error al cargar los datos, intente de nuevo.");
      }
      const cur = await response.json();
      setData(cur.data[0]);
      setIsLoading(false);
      return cur.data;
    } catch (e) {
      if (e instanceof TypeError) {
        throw new Error("No se pudo conectar al servidor.");
      }
      throw new Error(e.message);
    }
  };

  const handleReload = (
    message = "Los datos se actualizaron satisfactoriamente.",
  ) => {
    setColumns([]);
    setData([]);
    setIsLoading(true);
    toast.promise(fetchData(), {
      loading: "Cargando los datos...",
      success: message,
      error: (error) => {
        return error.message || "Error al cargar los datos.";
      },
    });
  };

  useEffect(() => {
    handleReload("Operacion exitosa.");
  }, [url, changes]);

  const handleUpdate = (element) => {
    setIsModalUpdateOpen(true);
    setToUpdate(element);
  };

  const handleDelete = (element) => {
    setIsModalDeleteOpen(true);
    setToDelete(element);
  };

  const handleAdd = () => {
    setIsModalAddOpen(true);
  };
  const handleSelectColumns = (index, flag) => {
    let aux = [];
    for (let i = 0; i < columns.length; i++) {
      if (index === i) {
        aux.push(flag);
      } else aux.push(selectedColumns[i]);
    }
    setSelectedColumns(aux);
  };

  return (
    <div className="flex flex-col w-full overflow-hidden">
      <Toaster richColors />

      <ProductsHeader
        columns={columns}
        callReload={handleReload}
        callAdd={handleAdd}
        selectedColumns={selectedColumns}
        changeSelectedColumns={handleSelectColumns}
      />

      <UpdateModal
        isOpen={isModalUpdateOpen}
        changeState={setIsModalUpdateOpen}
        toUpdate={toUpdate}
      ></UpdateModal>

      <DeleteModal
        isOpen={isModalDeleteOpen}
        changeState={setIsModalDeleteOpen}
        toDelete={toDelete}
      ></DeleteModal>

      <AddModal
        isOpen={isModalAddOpen}
        changeState={setIsModalAddOpen}
      ></AddModal>

      {data.length ? (
        <div className="flex px-5 py-10 ">
          <div className="flex overflow-y-auto max-h-[800px] min-w-full">
            <table className="table border-r border-slate-200 border-b max-h-[800px] overflow-x-auto min-w-full">
              <thead className="sticky top-0 table-header-group bg-slate-50 text-sm text-slate-400 font-medium z-30 ">
                <div className="table-row">
                  {columns.map((it, index) => (
                    <div
                      key={index}
                      className={
                        selectedColumns[index]
                          ? `flex-grow table-cell p-4 h-5 first:sticky first:left-0 first:z-20 first:bg-slate-50 ${it === "Options" ? "max-w-[100px]" : ""}`
                          : "hidden"
                      }
                    >
                      {capitalize(it)}
                    </div>
                  ))}
                </div>
              </thead>

              <div className="table-row-group">
                {data.map((it) => (
                  <div
                    key={it.id}
                    className="table-row h-['40px] max-h-[100px]"
                  >
                    {columns.map((column, index) =>
                      column === "Options" ? (
                        <div
                          className={
                            selectedColumns[index]
                              ? "sticky left-0 flex justify-evenly items-center h-[48px] text-md font-semibold bg-white max-w-[100px]"
                              : "hidden"
                          }
                        >
                          <MdDeleteForever
                            className="text-lg font-semibold"
                            onClick={() => handleDelete(it)}
                          />
                          <GrEdit
                            className="text-lg font-semibold"
                            onClick={() => handleUpdate(it)}
                          />
                        </div>
                      ) : (
                        <div
                          className={
                            selectedColumns[index]
                              ? `table-cell max-h-[100px] py-3 px-4 truncate text-slate-500 text-md ${column === "price" ? "text-right tabular-nums" : ""}`
                              : "hidden"
                          }
                        >
                          {it[column]}
                        </div>
                      ),
                    )}
                  </div>
                ))}
              </div>
            </table>
          </div>
        </div>
      ) : (
        !isLoading && (
          <div className="flex p-10">
            <h1 className="font-Roboto text-2xl font-semibold">
              No se encontro ninguna coincidencia.
            </h1>
          </div>
        )
      )}
    </div>
  );
};

export default DashboardProducts;
